<template lang="pug">
.marketPage
  page-title
    |{{ $t('pages.market') }}
    template(v-slot:helpTitle)
      h3 {{ $t('pages.market') }}
    template(v-slot:help)
      nl2br(tag="p" :text="$t('help.detail.market')")

  nuxt-child

</template>

<script>
import Nl2br from 'vue-nl2br'
const PageTitle = () => import('@/components/molecules/PageTitle')

export default {
  components: {
    PageTitle,
    Nl2br,
  },
  fetch({ route, redirect }) {
    let routeName = String(route.name)
    if (
      (routeName.includes('heroes') ||
        routeName.includes('prime') ||
        routeName.includes('labo') ||
        routeName.includes('trade') ||
        routeName.includes('exchange') ||
        routeName.includes('landvolumeshop') ||
        routeName.includes('ppdshop')) == false
    )
      return redirect('/market/shop/heroes')
  },
}
</script>

<style lang="scss" scoped>
.marketPage {
  position: relative;
}

.tabs {
  svg {
    margin-right: 0.5rem;
  }
}

.pageHeader {
  &__right {
    a {
      border: 1px solid;
      border-radius: 1rem;
      color: $color-primary;
      display: block;
      line-height: 1;
      padding: 0.5rem 1rem;
      text-decoration: none;

      svg {
        margin-left: 0.5rem;
      }
    }
  }
}
</style>
